<template>
    <div class="menu">
        <ul>
            <li>
                <router-link to="/dashboard" class="dashboard" active-class="active" exact>
                    <div class="link-wrapper">
                        <a class="dashboard"> <icon class="dashboard-icon nav-icon" icon="dashboard" :height="15" :width="16" /> {{ $t('header.menu.dashboard') }}</a>
                    </div>
                </router-link>
            </li>
            <li>
                <router-link v-if="hasAnyRole(['SettingsView', 'Admin'])" :to="settingsDestination" class="dashboard" active-class="active">
                    <div class="link-wrapper">
                        <a class="settings"> <icon class="settings-icon nav-icon" icon="settings" :height="15" :width="16" /> {{ $t('header.menu.settings') }}</a>
                    </div>
                </router-link>
            </li>
            <li>
                <router-link v-if="hasAllRoles(['OrganizationView', 'FleetView', 'VehicleView'])" to="/report" class="dashboard" active-class="active">
                    <div class="link-wrapper">
                        <a href="#" class="reports"> <icon class="reports-icon nav-icon" icon="reports" :height="15" :width="16" /> {{ $t('header.menu.reports') }}</a>
                    </div>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>

import Icon from '@/components/atoms/Icon'

export default {
    name: 'Menu',
    components: {
        Icon
    },
    computed: {
        settingsDestination () {
            if (this.hasAllRoles(['DeviceView'])) return '/settings'
            if (this.hasAllRoles(['FleetView'])) return '/settings/fleets'
            if (this.hasAllRoles(['UserView'])) return '/settings/users'
            if (this.hasAllRoles(['DriverView'])) return '/settings/drivers'
            if (this.hasAllRoles(['OrganizationView'])) return '/settings/organizations'
        }
    }
}
</script>

<style scoped lang="scss">
.menu {
    display: flex;
    align-items: center;

    ul {
        padding: 0;
        margin-left: 20px;
        list-style: none;
        display: flex;

        @include breakpoint(md) {
            margin-left: 10px;
        }

        li {
            display: inline-block;
            color: $font;
            width: max-content;

            .active {
                a {
                    border-bottom: 6px solid $primary;
                }
            }

            &:first-child {
                .link-wrapper {
                    padding-left: 0;
                }
            }

            &:last-child {
                .link-wrapper {
                    padding-right: 0;
                    border-right-width: 0;
                }
            }

            .link-wrapper {
                border-right: 1px solid $font;
                padding: 0 10px;
                line-height: 0.9rem;

                @include breakpoint(md) {
                    padding: 0 19px;
                }

                a {
                    color: $font;
                    padding-bottom: 17px;
                    .nav-icon {
                        color: $icon-secondary;
                        margin-right: 7px;
                    }
                }
            }
        }
    }
}
</style>
